import { GalleryScreen } from "../../features/gallery";

/** FS-03 전시관 — 페이지는 조립만 한다(CSG 4.2). 화면 본체는 features/gallery */
export default function GalleryPage() {
  return <GalleryScreen />;
}
